import "./assets/js/nav-pills.js";
import "./assets/js/ripple-effect.js";
import "./assets/scss/material-dashboard.scss";
import "./assets/scss/manager.scss";

export default {
  install() {},
};
